import React from "react";
import classNames from "classnames";
import Icon from "components/Icon";
import ButtonIconOnly from "components/ButtonIconOnly";

const TextInput = ({
  id,
  dataCy,
  value,
  type = "text",
  name = "text",
  onChange,
  placeholder = "Enter text in this input",
  hasError = false,
  errorMessage = "Inline error message",
  isDisabled = false,
  buttonOneIcon,
  buttonOneAction,
  buttonTwoIcon,
  buttonTwoAction,
  validateInput,
  autoComplete
}) => {
  const handleChange = (e) => {
    const newValue = e.target.value;
    if (!validateInput || validateInput(newValue)) {
      onChange(e);
    }
  };
  return (
    <div className="relative flex flex-col w-full">
      {/* Input Container */}
      <div
        className={classNames(
          "relative flex items-center w-full rounded-lg px-4 py-[14px] tw-paragraph-lg transition-all tw-input-wrapper",
          hasError && "border border-[var(--color-alert)] hover-border-thicker-input-red",
          !hasError && !isDisabled && "border border-gray-100 hover-border-thicker-input",
          isDisabled ? "border border-gray-100 text-gray-400" : ""
        )}
      >
        {/* Text Input */}
        <input
          id={id}
          data-cy={dataCy}
          type={type}
          name={name}
          value={value}
          onChange={handleChange}
          disabled={isDisabled}
          placeholder=" "
          autoComplete={autoComplete}
          className="peer w-full outline-none bg-transparent text-gray-900 font-semibold"
        />

        {/* Floating Label */}
        <label
          htmlFor={id}
          className={classNames(
            "tw-paragraph-lg pointer-events-none",
            "bg-transparent absolute px-1 top-1/2 transform -translate-y-1/2 text-gray-400 transition-all cursor-text",
            "peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2",
            "peer-focus:top-[-12px] peer-focus:left-[16px] peer-focus:-translate-y-0 peer-focus:text-sm",
            "peer-not-placeholder-shown:top-[-12px] peer-not-placeholder-shown:left-[16px] peer-not-placeholder-shown:-translate-y-0 peer-not-placeholder-shown:text-sm",
            "peer-focus:bg-transparent peer-focus:z-10 label-background",
            "peer-not-placeholder-shown:before:content-[''] peer-not-placeholder-shown:before:absolute",
            "peer-not-placeholder-shown:before:bottom-0 peer-not-placeholder-shown:before:left-0 peer-not-placeholder-shown:before:right-0",
            "peer-not-placeholder-shown:before:h-[13px] peer-not-placeholder-shown:before:bg-white peer-not-placeholder-shown:before:z-[-1] peer-not-placeholder-shown:before:transform-translate-y-[-50%]",
            "peer-focus:before:content-[''] peer-focus:before:absolute",
            "peer-focus:before:bottom-0 peer-focus:before:left-0 peer-focus:before:right-0",
            "peer-focus:before:h-[13px] peer-focus:before:bg-white peer-focus:before:z-[-1] peer-focus:before:transform-translate-y-[-50%]"
          )}
        >
          {placeholder}
        </label>

        {/* Icons (if applicable) */}
        {(buttonOneIcon || buttonTwoIcon) &&
          <div className="flex items-center gap-2 h-[23px]">
            {buttonOneIcon && (
              <ButtonIconOnly
                id={`${id}-Button-One`}
                dataCy={`${id}-Button-One`}
                icon={buttonOneIcon}
                size={20}
                type="uncontained"
                onClick={buttonOneAction}
              />
            )}
            {buttonTwoIcon && (
              <ButtonIconOnly
                id={`${id}-Button-Two`}
                dataCy={`${id}-Button-Two`}
                icon={buttonTwoIcon}
                size={20}
                type="uncontained"
                onClick={buttonTwoAction}
              />
            )}
          </div>}
      </div>

      {/* Error Message */}
      {hasError && !isDisabled && (
        <div className="absolute left-0 top-full flex items-center gap-2 text-gray-800 mt-1 ml-4">
          <Icon name="circleAlert" size={20} fillColor="fill-[var(--color-alert)]" className="text-[var(--color-white)]" />
          <span
            id={`${id}-error-message`}
            data-cy={`${id}-error-message`}
            className="tw-paragraph-sm font-semibold"
          >
            {errorMessage}
          </span>
        </div>
      )}
    </div>
  );
};

export default TextInput;
